import AnimateObject from 'epic-fortnite-react/components/common/AnimateObject';
import PropTypes from 'prop-types';
import React, {useState} from 'react';

import AnimateString from '../common/AnimateString';
import VideoOverlay from '../common/VideoOverlay';
import VideoPlayButton from '../common/VideoPlayButton';

const VideoHeader = ({data}) => {
  const {logo, badge, bgImg, title, videoId, playText} = data;
  const [isPlay, setPlay] = useState(false);
  return (
    <div className="chapter2-header" style={{backgroundImage: `url(${bgImg})`}}>
      <div className="content">
        <div className="animated-content">
          {logo ? (
            <AnimateObject
              className="logo-img"
              minTop={20}
              speed={1.5}
              from={{
                y: `+=150`,
                autoAlpha: 0,
              }}
              to={{
                y: 0,
                autoAlpha: 1,
                delay: 0.3,
              }}>
              <img src={logo} alt="logo" />
            </AnimateObject>
          ) : null}
          {badge ? (
            <AnimateObject
              minTop={20}
              className="badge-img"
              speed={1.5}
              from={{
                y: `+=150`,
                autoAlpha: 0,
              }}
              to={{
                y: 0,
                autoAlpha: 1,
                delay: 0.3,
              }}>
              <img src={badge} alt="badge" />
            </AnimateObject>
          ) : null}
          <AnimateString
            key="videoHeader-Title"
            text={title}
            type="h1"
            speed={1.5}
            delay={0.3}
            autoAlpha={0}
            yPos={100}
            minTop={5}
            scaleFrom={1}
            staggerDelay={0}
          />
          <AnimateObject
            minTop={20}
            speed={1.5}
            className="play-wrapper"
            from={{
              y: `+=150`,
              autoAlpha: 0,
            }}
            to={{
              y: 0,
              autoAlpha: 1,
              delay: 0.3,
            }}>
            <>
              {playText ? <h3>{playText}</h3> : null}
              <VideoPlayButton onClick={() => setPlay(true)} className="bp-videoplay" />
            </>
          </AnimateObject>
        </div>
      </div>
      <div className="videoOverlay-wrapper">
        <VideoOverlay
          videoID={videoId}
          isLauncher={false}
          play={isPlay}
          close={() => setPlay(false)}
          closeButton
          show={isPlay}
        />
      </div>
    </div>
  );
};

VideoHeader.propTypes = {
  data: PropTypes.object,
};
export default VideoHeader;
